interface HeroProps {
  scrollToContact: () => void;
}

export default function Hero({ scrollToContact }: HeroProps) {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center pt-20 bg-cover bg-center"
      style={{
        backgroundImage: 'url(https://readdy.ai/api/search-image?query=Professional%20technician%20cleaning%20large%20commercial%20air%20conditioning%20unit%20in%20modern%20office%20building%2C%20wearing%20uniform%20and%20using%20professional%20equipment%2C%20clean%20industrial%20environment%20with%20white%20walls%20and%20blue%20accents%2C%20high%20quality%20professional%20photography%2C%20bright%20and%20clean%20atmosphere%2C%20focus%20on%20air%20conditioning%20maintenance%20work&width=1920&height=1080&seq=hero-aircon-001&orientation=landscape)',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-900/70 to-transparent"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-24 w-full">
        <div className="max-w-2xl">
          <div className="inline-block bg-cyan-500/20 backdrop-blur-sm border border-cyan-400/30 px-4 py-2 rounded-full mb-6">
            <span className="text-cyan-300 text-sm font-semibold">法人のお客様に寄り添うサポート</span>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            法人向けの<br />
            実務支援と<br />
            <span className="text-cyan-400">柔軟なご提案</span>
          </h1>
          
          <p className="text-xl text-gray-200 mb-8 leading-relaxed">
            事業内容や運営状況に応じて、<br />
            必要なサポートを丁寧にご案内いたします。
          </p>
          
          <div className="flex flex-wrap gap-4">
            <button 
              onClick={scrollToContact}
              className="bg-cyan-600 text-white px-8 py-4 rounded-md font-semibold hover:bg-cyan-700 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              お問い合わせ
            </button>
            <button 
              onClick={() => {
                const element = document.getElementById('services');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-8 py-4 rounded-md font-semibold hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
            >
              サービスを見る
            </button>
          </div>
          
          <div className="mt-12 grid grid-cols-3 gap-6">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-4 rounded-lg">
              <div className="text-3xl font-bold text-cyan-400 mb-1">法人向け</div>
              <div className="text-sm text-gray-300">事業者様対応</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-4 rounded-lg">
              <div className="text-3xl font-bold text-cyan-400 mb-1">丁寧</div>
              <div className="text-sm text-gray-300">ヒアリング重視</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-4 rounded-lg">
              <div className="text-3xl font-bold text-cyan-400 mb-1">柔軟</div>
              <div className="text-sm text-gray-300">状況に応じてご案内</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
